import { render, staticRenderFns } from "./CreateFromKKEDialog.vue?vue&type=template&id=60680448&"
import script from "./CreateFromKKEDialog.vue?vue&type=script&lang=js&"
export * from "./CreateFromKKEDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports